import { useSelector } from "react-redux";
import { getGoogleDriveConfig, getDropboxConfig } from "~/store/selectors/selector.configOptions.jsx";

const GOOGLE_DRIVE_PICKER_API_KEY = process.env.GOOGLE_DRIVE_PICKER_API_KEY;

export const useFileIntegrations = () => {
  const googleDrive = useSelector(getGoogleDriveConfig);
  const dropboxAppKey = useSelector(getDropboxConfig);
  const googleDriveAppId = googleDrive.get(`app_id`);
  const googleDriveClientId = googleDrive.get(`client_id`);
  const googleDriveApiKey = GOOGLE_DRIVE_PICKER_API_KEY || undefined;
  const showDropbox = !!dropboxAppKey;
  const showGoogleDrive = !!googleDriveClientId && !!googleDriveAppId;
  const hasAttachmentIntegration = showGoogleDrive || showDropbox;

  return {
    googleDrive,
    dropboxAppKey,
    googleDriveAppId,
    googleDriveClientId,
    showDropbox,
    showGoogleDrive,
    hasAttachmentIntegration,
    googleDriveApiKey,
  };
};
